import { Injectable, Renderer2, RendererFactory2} from '@angular/core';
// import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalsService } from '../services/globals.service';
import { ToastController, AlertController } from '@ionic/angular';
import { Els } from '../services/els.service';
import { Device } from '@capacitor/device';

@Injectable({providedIn: 'root'})

export class UtilService {

private renderer: Renderer2;
isNumber = (n: string | number): boolean => !isNaN(parseFloat(String(n))) && isFinite(Number(n));
delay = ms => new Promise(res => setTimeout(res, ms));

constructor(
  private gs: GlobalsService,
  private _renderer: RendererFactory2,
  public toastController: ToastController,
  public alert: AlertController,
  private els: Els, 
) { this.renderer = _renderer.createRenderer(null, null);}

goScrollToTop() {
  var content = document.querySelector('ion-content') as HTMLIonContentElement ;
  content.scrollToTop(200);
}

getSubdomain(hostname) {
  var regexParse = new RegExp('[a-z\-0-9]{2,63}\.[a-z\.]{2,5}$');
  var urlParts = regexParse.exec(hostname);
  return hostname.replace(urlParts[0],'').slice(0, -1);
}

async getDevInfo () {
  // console.error( window.location.href); 
  console.error( window.location.hostname); 

  this.gs.url_prefix = this.getSubdomain(window.location.hostname);
  this.gs.path = window.location.pathname.substring(1);
  window.history.pushState(this.gs.path, "ReachMe App", '' );

  if (window.location.href.indexOf('//a.reachme.com') > -1) {
    this.gs.reachmeUrl = '/websrv/dev/';
    // this.gs.reachmeUrl = '/tmp/a/index.php';
    // this.gs.path = '2135342255';
  }

  try {
  const info = await Device.getInfo();
  if (info !== null || info !== undefined ) {
    this.gs.deviceInfo = JSON.stringify(info);
    this.gs.deviceOP = info['operatingSystem'];
    console.log(info)
  }
  this.gs.duuid = (await Device.getId()).uuid;
  } catch (e) {console.error('No uuid');}

  if (this.gs.duuid === null || this.gs.duuid === undefined || this.gs.duuid == '') this.gs.generateGUID ();
}

getDevLocalSsettings () {
  this.gs.rpsw = localStorage.getItem('rpsw'); if (this.gs.rpsw === null) this.gs.rpsw = '';
}

addListenerDIDs (actID) {
  let e = document.getElementById (actID)
  if (e !== null) e.addEventListener("click", () => this.getTabButClick (actID));
}


// URL POST       ////$$$
DIDgoUrl (actData, subID) {
  this.goUrl (this.gs.DID_Postdata (actData, subID), '');
}
async goUrl (postData, gID) {
  console.log(postData);
  await this.gs.postUrl (this.gs.reachmeUrl,  postData).subscribe( 
    res => this.getUrlRes (gID, res), error => this.getUrlError (error));
}

getUrlError (error) {
  this.gs.actionRes = 0;
  if (error == '') return; 
  console.error(JSON.stringify(error)) ;
  this.gs.presentToast(this.gs.urlErrMsg, 'danger', 1500);
}

getUrlRes (gID, res) {   console.log(res);
  this.gs.actionRes = 0;
  let retData = JSON.parse(JSON.stringify(res));
  let msg = retData['msg'] !== undefined ? retData['msg'] : '';
  let bgDat = retData['bgDat'] !== undefined ? retData['bgDat'] : '';
  let actID = retData['actID'] !== undefined ? retData['actID'] : '';
  let subID = retData['subID'] !== undefined ? retData['subID'] : '';
  let actData = retData['actData'] !== undefined ? retData['actData'] : '';
  let result = retData['result'] !== undefined ? String(retData['result']) : '1';
  this.gs.refrence = retData['refrence'] !== undefined ? retData['refrence'] : '';
  let bg = retData['bg'] !== undefined ? retData['bg'] : '';
  let err = retData['errmsg'] !== undefined ? retData['errmsg'] : '';

  if (bgDat != '') { switch (bg) {case 'Audio':  this.gs.uvmGrsA = JSON.parse(bgDat); break ;} }
  if (actData != '') { this.getUVMdidDiv (subID, actData); return;}

  if (result == '0') { if (msg != '') this.gs.presentToast(msg, 'danger', 1500); return; }
  else {
    if (msg != '') this.gs.presentToast(msg, 'success', 1000);
    if (subID == 'Notifs') { this.onSegmentChange('segsDID', subID); }
  }

  if (err != '') { this.gs.presentToast(err, 'warning', 1500);  return ; }

  if (gID.toString().indexOf('smsTID') == 0) { this.els.smsSentReturn (gID, msg); return; }
  if (gID != '') this.msgActionProc (gID, actID );
}


// SEGMENT       ////$$$
async onSegmentChange (segID, s) {
  switch (segID) {
  case 'segsDID':
    this.gs.bg = '';
    if (this.els.ifDispBlock ('savTrf' + '_item') == 1) {
      if ( await this.chkSaveTrfs () == '0') return;
    }
    this.gs.didSegSel = s;
    if (this.gs.uvmGrsA.length == 0) this.gs.bg = 'Audio';
    this.DIDgoUrl ('', s);
    break;

  case 'segsMsgs':
    s = (s + ' ').split (' ')[0];
    if (s == '') break;
    this.refreshItemsVis (s, 0);
    break;
  }
}

// DIDs SETUP       ////$$$
getDIDsDiv (did) {
  let e = this.els.clearInnerHTML ('didsIdsub'); if (e === null) return;
  this.renderer.setAttribute(e, 'class', 'did-setup-div'); 
  if (this.els.getSelDID (did) != '') this.gs.didSel = did;
  this.renderer.appendChild(e, this.els.getIdsListDiv (this.getIdsList ()));
  let segs = this.els.getSegsDIDset ( e);
  segs.addEventListener('ionChange', (ev) => this.onSegmentChange('segsDID', ev.detail.value));
  this.els.sh_DIDsDivs (this.gs.showByClass);
}

getIdsList () {
  let div = this.els.createElem ('div', 'didns');
  let item = this.els.createElem ('ion-item'); 

  if ( this.gs.didSel == '' ) {
    if (  this.gs.allUsersA[0] ) this.gs.didSel = this.gs.allUsersA[0]; 
  }
  let sel = this.els.select_El ('didf', this.gs.didSel, this.gs.allUsersA);
  sel.addEventListener("ionChange", () => { this.didSel( sel.value ); });

  sel.value = this.gs.didSel;

  this.renderer.appendChild(item, sel);
  this.renderer.appendChild(div, item);
  return div;
}

didSel ( id ) { 
  this.gs.didSel = id; 
  let segs = document.getElementById ('segsDID') as HTMLIonSegmentElement ;
  if (segs == null) return;
  this.gs.bg = ''; if (this.gs.uvmGrsA.length == 0) this.gs.bg = 'Audio';
  if (this.gs.didSegSel == '') console.error('.didSegSel');
  this.DIDgoUrl ('', this.gs.didSegSel);
}

async infoMainClicked () { 
  this.goScrollToTop();
  let e = document.getElementById ('infoMainIco') as HTMLIonIconElement ; if (e === null) return;
  this.els.sh_msgFiltsID (this.gs.hideByClass);
  if (e.name != this.gs.ICO_X) {
    e.name = this.gs.ICO_X;
    this.getDIDsDiv (this.gs.didSel) ;
  }
  else {
    if (this.els.ifDispBlock ('savTrf' + '_item') == 1) {if ( await this.chkSaveTrfs () == '0') return;}
    this.els.closeMtabstop (e);
  }
}

msgActionProc (gID, actID) {
  // if (auto red)
  this.els.openMenu ('m1', 0);
  let ind = this.gs.findInd (gID); if (ind == -1) return;  // tmp remove later
  this.doMsgActionRet (ind, actID);
  this.gs.refrence == '';
  let segs = this.els.createGSsigsTab();
  segs.addEventListener('ionChange', (ev) => this.onSegmentChange('segsMsgs', ev.detail.value));

  if (actID.indexOf ('all') > -1) {
    this.refreshItemsVis ('', 1); 
    this.els.setInnerHDat ('totmsgs', 'Total ' + this.gs.msgsAllTotal);
  }
}

getCheckRow (l, chkBoxID, active, clas, toggle, listen, cap) {
  let checkbox;
  if (toggle == 1) checkbox = this.els.createElem ('ion-toggle', chkBoxID);
  else checkbox = this.els.createElem ('ion-checkbox', chkBoxID);
 
  const item = this.els.getCheckRow (checkbox, l, chkBoxID, active, clas, toggle, cap);
  if (listen == 1) checkbox.addEventListener("click", () => { this.UVMchkChanged (chkBoxID); });
  return item;
}

getEmails (a) {
    let div = this.els.createElem ('div');
    let e;
    let ad = a[0]['address'];
    if (a[0]['sms'] == true) {
      let ret = ad.indexOf('@' );
      if (ret > -1 ) ad = 'Txt: ' + ad.substring(0, ret);
    }
    let id = 'xr-' + a[0]['xrefEmailId'] ;

    e = this.getCheckRow (ad, id + '-0', a[0]['active'], 'uvm-title', 1, 1, ''); 
    this.renderer.appendChild(div, e);
   this.getButWIcon (id + '-emdel', e, this.gs.ICO_TRASH, 'Delete', 'end') ;

    // this.renderer.appendChild(e, this.getButWIcon (id + '-0', e, ICO_TRASH, 'Delete', 'end'));

    e = this.getCheckRow ('Voice Messages', id+ '-1', a[0]['vmLink'], '', 0, 1 , ''); this.renderer.appendChild(div, e);
    e = this.getCheckRow ('Faxes', id+ '-2', a[0]['faxLink'], '', 0, 1 , ''); this.renderer.appendChild(div, e);
    e = this.getCheckRow ('SMS/Text Messages', id+ '-3', a[0]['text'], '', 0, 1 , ''); this.renderer.appendChild(div, e);
    e = this.getCheckRow ('Numeric Messages', id+ '-4', a[0]['numeric'], '', 0, 1 , ''); this.renderer.appendChild(div, e);
    e = this.getCheckRow ('Missed Calls', id+ '-5', a[0]['callerId'], '', 0, 1 , ''); this.renderer.appendChild(div, e);

    // if (a[0]['sm s'] == false) {
      e = this.getCheckRow ('Inbound Recorded Calls', id+ '-6', a[0]['inbound'], '', 0, 1 , ''); this.renderer.appendChild(div, e);
      e = this.getCheckRow ('Outbound Recorded Calls', id+ '-7', a[0]['outbound'], '', 0, 1 , ''); this.renderer.appendChild(div, e);
      e = this.getCheckRow ('Recorded Conference Calls', id+ '-8', a[0]['conf'], '', 0, 1 , ''); this.renderer.appendChild(div, e);
    // }
    
    this.renderer.setAttribute(div, 'class', 'uvm-setups');
    return div;
}

getButWIcon (id, item, ico, cap, slot) {
  let but = this.els.getTabBut (id, ico, cap, '');
  but.addEventListener("click", () => this.getTabButClick (id));
  this.renderer.setAttribute(but, 'slot', slot);
  this.renderer.appendChild(item, but);
  return but;
}

UVMchkChanged (id) {
  let e = document.getElementById (id) as HTMLIonCheckboxElement; if (e === null) {return;}
  this.gs.showAlert('Save?', '', '').then (res => {
      if (this.gs.resultRet == '1') {
        if (this.gs.didSel == '') return
        let s = id + '-' + e.checked;
        this.gs.bg = '';
        if (s.indexOf('uvmFils') == 0 ) this.DIDgoUrl (s, 'filsave');
        else this.DIDgoUrl (s, 'emsav');
      }
      else { if (e.checked == true) e.checked = false;  else e.checked = true; }
    })
}

getDidFilters (keys, vals) {
  let div = this.els.createElem ('div');
  for (let i = 0; i < vals.length; i++) {
    let e = this.getCheckRow (keys[i], 'uvmFils-' + i, vals[i], 'uvm-title', 0, 1 , ''); 
    this.renderer.appendChild(div, e);
  }
  this.renderer.setAttribute(div, 'class', 'uvm-setups');
  return div;
}

getUVMdidDiv (subID, actData) {

    let div = this.els.getUVMdiv (subID);
    this.addListenerDIDs ('addsms');

    if (actData == '') { console.error ('actData'); return; }

    const res = JSON.parse(actData);
    let keys = Array();
    let vals = Array();
    if (res != '[]') {
      keys = Object.keys(res);
      vals = Object.values(res);
    }
    switch (subID) {
      case 'Notifs': 
        for (let i = 0; i < vals.length; i++) {
          this.renderer.appendChild(div, this.getEmails (vals[i]));} 
          break;
      case 'Routing': 
        this.renderer.appendChild(div,  this.els.getTrfs (res, keys, vals));
        this.addListenerDIDs ('savTrf');
        break;
      case 'Filters': this.renderer.appendChild(div, this.getDidFilters (keys, vals)); break;
      // case 'Audio': this.gs.uvmGrsA = res; this.renderer.appendChild(div, this.getUvmAudio ( )); return div;
    }
  }

async getTabButClick (actID) {
  switch (actID) {
  case 'savnewem': {
    if (this.gs.didSel == '') return;
    this.gs.showAlert('Save the New Notification?', '', '').then (res => {
      if (this.gs.resultRet == '1') {
        let s = this.els.getNotifForm () ;
        if (s =='') return;
        this.gs.bg = '';
        this.DIDgoUrl (s, 'savnewem');
      }
    })
    break;
  } 
 case 'addsms': {
    this.gs.showAlert('Add a New Text/SMS Notification?', '', '').then (res => {
      if (this.gs.resultRet == '1') {this.getAddNotifs (actID);}
    })
    break;
  }
  case 'savTrf': {
    if (this.gs.didSel == '') return;
    if ( await this.chkSaveTrfs () == '0') return;
    this.infoMainClicked();
    break;
  }
  default:  //  id = 'xr-' + this.gs.  [0]['xrefEmailId'] ;
    if (actID.indexOf('-emdel') != -1) {
      if (this.gs.didSel == '') return;
      this.gs.showAlert('Delete?', '', '').then (res => {
        if (this.gs.resultRet == '1') { 
          this.gs.bg = '';
          this.DIDgoUrl (actID + '-' + 'emdel', 'emdel'); }
      })
    }
    break;
  
  }
}

async chkSaveTrfs () {
  await this.gs.AsyncShowAlert ('Save the New Settings?', '');
  switch (this.gs.resultRet) {
  case '1': 
    this.els.hideUnhideElement ('savTrf' + '_item', 'none');
    let s =  this.els.getRoutForm ();
    this.gs.bg = '';
    if (s !='') this.DIDgoUrl (s, 'savTrf');
    break;
  }
  return this.gs.resultRet;
}

getAddNotifs (id) {
  let div = this.els.clearInnerHTML ('addnotifs'); 
  if (div === null) div = this.els.createElem ('div', 'addnotifs', '', '', 'uvm-setups');

  let e;
  e = this.getCheckRow ('', id + '-0', true, 'uvm-title-form', 1, 0,  "Email or SMS Number"); this.renderer.appendChild(div, e);
  this.getButWIcon ('savnewem', e, this.gs.ICO_RED, 'Save', 'end');
  
  e = this.getCheckRow ('Voice Messages', id+ '-1', true, '' , 0, 0, ''); this.renderer.appendChild(div, e);
  e = this.getCheckRow ('Faxes', id+ '-2', true, '' , 0, 0, ''); this.renderer.appendChild(div, e);
  e = this.getCheckRow ('SMS/Text Messages', id+ '-3', true, '' , 0, 0, ''); this.renderer.appendChild(div, e);
  e = this.getCheckRow ('Numeric Messages', id+ '-4', true, '' , 0, 0, ''); this.renderer.appendChild(div, e);
  e = this.getCheckRow ('Missed Calls', id+ '-5', true, '' , 0, 0, ''); this.renderer.appendChild(div, e);

  // no sms ??????????????????????
  e = this.getCheckRow ('Inbound Recorded Calls', id+ '-6', true, '' , 0, 0, ''); this.renderer.appendChild(div, e);
  e = this.getCheckRow ('Outbound Recorded Calls', id+ '-7', true, '' , 0, 0, ''); this.renderer.appendChild(div, e);
  e = this.getCheckRow ('Recorded Conference Calls', id+ '-8', true, '' , 0, 0, ''); this.renderer.appendChild(div, e);

  return div;
}

getMenuItem1 (gID, act, name, cap, color) {
  let label = this.els.createElem ('ion-label', '', cap); 
  let item = this.els.getMenuItem1 (label, name, color);
  label.addEventListener("click", () => { this. actionProccess (act, gID, 1, act);});
  return item;
}

getContMenu (gID) {
  let l; let d; let s = '';
  let mu = this.els.clearInnerHTML ('mmenu'); if (mu === null) return;

  let ind = this.gs.findInd (gID); if (ind == -1) return;  // tmp remove later
  let a = this.gs.getAssocMsgArray (ind );

  const content = this.els.createElem ('ion-content'); 
  const list = this.els.createElem ('ion-list'); 
  const header = this.els.createElem ('ion-header');
  const toolbar = this.els.createElem ('ion-toolbar');
  const title = this.els.createElem ('ion-item', '', this.gs.ifIsPhOrExt(this.gs.ITMS[ind]['a'][this.gs.conOffS], 1));
  this.renderer.appendChild(toolbar, this.els.createMsgImage());
  this.renderer.setAttribute(title, 'slot', 'start');

  this.renderer.appendChild(header, toolbar);
  this.renderer.appendChild(toolbar, title);
  this.renderer.appendChild(content, list);

  let es = 'ion-input ;; id = cname ;; data-cname = ' + a['cname'];
  es += ' ;; value = ' + a['cname'];
  let txt = this.els.getEL ( es);

  const itm = this.els.createElem ('ion-item');
  this.renderer.appendChild(itm, txt);
  this.renderer.appendChild(mu, itm);

  l = '<ion-label color="primary" class="menu-label" >Actions on All Messages from this Contact</ion-label>'
  d = this.els.createElem ('ion-item-divider');  d.innerHTML = l;   this.renderer.appendChild(mu, d);
  
  let m = ' All the Messages';
  this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'blk', 'close-circle', 'Block The Caller', 'danger'));

  s = 'Flag' + m;  this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'flgall', this.gs.ICO_FLG, s, 'danger'));
  s = 'UnFlag' + m;  this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'uflgall', this.gs.ICO_FLG, s, 'success'));
  
  if (a['type'] != this.gs.MSGS_TYPE_SENT && a[this.gs.p_fixOffset] != 'r_') {
    s = 'Mark Read' + m;  this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'redall', this.gs.ICO_RED, s, 'gray'));
    s = 'Mark UnRead' + m;  this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'uredall', this.gs.ICO_DOWNLOAD, s, 'success'));
    s = 'Delete' + m;  this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'delall', this.gs.ICO_TRASH, s, 'danger'));
    s = 'UnDelete' + m;  this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'udelall', this.gs.ICO_RECYCL, s, 'success'));
    // s = 'Purge' + m; this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'pugall', 'trash', s, 'danger'));
  }

  this.renderer.appendChild(mu, header);
  this.renderer.appendChild(mu, content);
  this.els.openMenu ('m1', 1);
}

mmenuClose () {
  let cn = document.getElementById('cname') as HTMLInputElement  ; 
  if (cn === null || cn.value == cn.dataset.cname)  return;
  this.gs.showAlert('Contact Name Is Changed', this.gs.askToSave, '').then (res => {
    if (this.gs.resultRet == '1') {
      this.saveContactNameUrl (cn);
      this.els.openMenu ('m1', 0);
    }
    else if (this.gs.resultRet == '0') { this.els.openMenu ('m1', 1); return; }
  })
}

getFooter () {  
  let e = document.getElementById ('mtabs');  if (e === null) {console.error('m=tabs'); return;}

  let buts = this.els.buttons_El ('slot="start"', '', 'color="teritiary" ;; name="' + this.gs.ICO_CHAT_FILL + '"', '---', '---');
  buts.addEventListener("click", () => { this.getGsmsDiv ('g', 1); });
  
  // let buts2 = this.els.buttons_El ('slot="start"', '', 'color="dark" ;; name="' + this.gs.ICO_OUTCALL + '"', '---', '---');
  // buts2.addEventListener("click", () => { this.getCallDiv (''); });

  let buts3 = this.els.buttons_El ('slot="end"', '', 'color="dark" ;; name="' + this.gs.ICO_UP + '"', '---', '---');
  buts3.addEventListener("click", () => { this.goScrollToTop (); });


  this.renderer.appendChild(e, buts);
  // this.renderer.appendChild(e, buts2);
  this.renderer.appendChild(e, buts3);
}

// MSGS LIST ITEMS       ////$$$
getActionEl (ico, elId, gID, colID, badge, slot) {
  let bdg = '---';
  if (badge != '') {
    let c = this.gs.countHis (gID);
    bdg = 'innerHTML="' + String(c + 1) + '" ;; id="timer44";; name="timer-outline" ;; style="font-size: 10px;margin-left: -24px;margin-top: 10px;"'
  }
  let buts = this.els.buttons_El ('id="' + colID + '" ;; slot="'+ slot + '"', '', 'style="margin:2px;" ;; color="warrning" ;; name="' + ico + '"', '---', bdg);
  buts.addEventListener("click", () => { this.getActionClick(elId, gID); });
  return buts;
}

getItemActionBar (gID, ind, a) {
  let tb = this.els.createElem ('ion-toolbar', gID + '_from', '', '', 'act-bar');
  this.renderer.appendChild (tb, this.getActionEl (this.gs.ICO_PERSON, 'mmp', gID, '', '', 'start'));
  this.renderer.appendChild (tb, this.getActionEl (this.gs.ICO_SETTINGS, 'mm', gID, '', '', 'start'));
  if ( this.gs.countHis (gID) > 0) 
    this.renderer.appendChild(tb, this.getActionEl (this.gs.ICO_HISTORY, '3', gID, '', 'yes', 'start'));
    
  let format = a['format'];
  if ( format != this.gs. MSGS_FORMAT_TIF
    && format != this.gs.MSGS_FORMAT_PDF
    && format != this.gs.MSGS_FORMAT_TIF_PDF
    ){
      let to = this.gs.ifIsPh(this.gs.ITMS[ind]['a'][this.gs.conOffS], 0);
      let from = this.gs.if_HasSmsDID (this.gs.didSel, 0);
      if ( from != '' && to != '') {
        tb.setAttribute ('data-from', from + '??' + to);
        this.renderer.appendChild(tb, this.getActionEl (this.gs.ICO_CHAT_FILL, '0', gID, '', '', 'end'));
      }
    }
    return tb;
}

getMsgMenu (gID) {
  let mu = this.els.clearInnerHTML ('mmenu'); if (mu === null) return;
  let ind = this.gs.findInd (gID); if (ind == -1) return;  // tmp remove later
  let a = this.gs.getAssocMsgArray (ind);

  if (a['flags'] & this.gs.MSGS_FLAGS_FLAGGED) 
        this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'uflg', this.gs.ICO_FLG, 'UnFlag', 'success'));
  else  this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'flg', this.gs.ICO_FLG, 'Flag This Message', 'gray'));
  
  if (a['type'] != this.gs.MSGS_TYPE_SENT && a[this.gs.p_fix] == 'm_') {
    if (a['state'] == this.gs.MSGS_STATE_READ) 
          this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'ured', this.gs.ICO_DOWNLOAD, 'Mark as New', 'success'));
    else  this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'red', this.gs.ICO_RED, 'Mark as Read', 'gray'));
 
    if (a['state'] == this.gs.MSGS_STATE_DELETED) 
          this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'udel', this.gs.ICO_RECYCL, 'Restore', 'success'));
    else  this.renderer.appendChild(mu, this.getMenuItem1 (gID, 'del', 'trash', 'Recycle', 'danger'));
 }
  this.els.getMsgMenu (gID, mu);
  this.els.openMenu ('m1', 1);
}

selectAnItem (gID) {
  document.documentElement.style.setProperty('--itemsColor', 'lightgrey');
  let ind = this.gs.findInd (gID); if (ind == -1) return;  // tmp remove later
  let a = this.gs.getAssocMsgArray (ind);
  this.els.getItemsSelected (gID)
  let ei = document.getElementById(gID); if (ei === null) { console.error(gID + ' = null'); return; }
  this.gs.activeID = Number(ind);
  this.els.addRemClass_e (ei, 'itemWhite', this.gs.hideByClass);
  this.els.addRemClass_e (ei, 'itemsClass', this.gs.showByClass);
  if (a['p_fix'] == 'm_') {this.els.insertItmRow (this.gs.clickedItemId, 'mr_', this.els.getMsgDet (ind, a, 0));}

  this.els.insertItmRow (this.gs.clickedItemId,  'ar_', this.getItemActionBar (gID, ind, a));

  let txtId = 'sms_' + gID + '_txt';
  let smsT = this.gs.get_LS (txtId);
  if (smsT != '') {
    this.els.setInnerHDat (txtId, smsT);
    this.getActionClick('0', gID);
  }

  // // // this.autoRead (a, gID);
}
getItemClick (gID, remDivs) {
  document.documentElement.style.setProperty('--itemsColor', 'white');
  this.gs.activeID = -1;
  if (remDivs == 1) this.els.sh_allTopDivs (this.gs.hideByClass);
  if (this.gs.clickedItemId != '') this.els.deselectAnItem (gID);
  if (this.gs.clickedItemId == gID) {this.gs.clickedItemId =  ''; return;}
  this.gs.clickedItemId = gID;
  this.selectAnItem (gID);
}
ifClickedItemId () {
  if (this.gs.clickedItemId != '' && this.gs.activeID > -1) {
    this.getItemClick(this.gs.getID(this.gs.activeID), 0);
    this.els.sh_msgFiltsID (this.gs.showByClass);
  }
}

showHideEl (ind: number, show, noShow, insertTop) {
  this.gs.ITMS[ ind ]['a'][ this.gs.isVis] = show; 
  let gID = this.gs.getID (ind);
  let r1_id = 'r1_' + gID; 
  if (show == 0) { 
    if (this.gs.ITMS[ ind ]['a'][ this.gs.isLoaded] == 1) this.els.deleteElement (r1_id);
    this.gs.ITMS[ ind ]['a'][ this.gs.isLoaded] = 0; 
    return;
  }
  if (noShow == 1) return;

  this.gs.ITMS[ ind ]['a'][ this.gs.isLoaded] = 1;

  let a = this.gs.getAssocMsgArray (ind );
  let slides = this.getItemSlidElement (ind, a, 1, gID);
  this.renderer.appendChild(slides, this.getItemG (r1_id, ind, gID, a));

  if (insertTop == 0) 
        document.getElementById('mainDiv').appendChild (slides);
  else  document.getElementById('mainDiv').prepend (slides);
}

getItemG (r1_id, ind, gID, a) {
  let item = document.getElementById(r1_id); if (item !== null) {item.innerHTML = ''; }
  else {item = this.els.createElem ('ion-item', r1_id, '', '', 'itemsClass'); }

  let topRow = this.els.getListStateBar(ind, gID, a);
  let mainRow = this.els.createElem ('ion-row', 'tr_' + gID);
  mainRow.addEventListener("click", () => { this.getItemClick(gID, 1);});
  this.renderer.appendChild(mainRow, this.els.createLisE (ind, a, topRow));

  let mainGrid = this.els.createElem ('ion-grid', gID, '', '', 'itemsClass') as HTMLIonGridElement;
  this.renderer.appendChild(mainGrid, mainRow);
  this.renderer.appendChild(item, mainGrid);
  return item;
}

getItemSlidE (ee, id, side) {
  let e = document.getElementById (id);  if (e !== null ) return e;
  e = this.els.createElem ('ion-item-options', id); 
  this.renderer.setAttribute(e, 'side', side);
  this.renderer.appendChild(ee, e);
  return e;
}

getItemSlidElement (ind: number, a, appen, gID) {
  let id = gID + '_sl';
  let slides = document.getElementById (id); 
  if (slides === null) { slides = this.els.createElem ('ion-item-sliding', id); }
  let sliStart = this.getItemSlidE (slides, 'Sops_' + gID, 'start');
  let sliEnd = this.getItemSlidE (slides, 'Sope_' + gID, 'end');
  this.getSlideButs (a, ind, sliStart, sliEnd, appen, gID);
  return slides;
}

getSlideButs (a, ind, sliStart, sliEnd, appen, gID) {
  if (sliStart === null || sliEnd === null ) return;
  if (a['type'] == this.gs.MSGS_TYPE_VOICEMAIL && a['p_fix'] == 'm_') {
    this.setSlideAttr_del (sliEnd, a, appen, gID, 'del');
    this.setSlideAttr_red (sliStart, a, appen, gID, 'red');
  }
  this.setSlideAttr_blk (sliEnd, ind, appen, gID, 'blk');
  this.setSlideAttr_flag (sliStart, ind, appen, gID, 'flg');
}

setSlideAttr_del (ee, a, appen, gID, idsufix) {
  let e = null;
  if (a['state'] == this.gs.MSGS_STATE_DELETED) {
    e = this.getSlideOptionEl (gID, 'udel', this.gs.ICO_RECYCL, 'success', 'UnDelete', idsufix); }
  else { e = this.getSlideOptionEl (gID, 'del', 'trash', 'danger', 'Trash', idsufix); }
  if (appen == 1) this.renderer.appendChild(ee, e);
}
setSlideAttr_red (ee, a, append, gID, idsufix) {
  let color = 'dark';  let e = null;

  if (a['state'] == this.gs.MSGS_STATE_UNREAD) { 
    color = 'primary';
    e = this.getSlideOptionEl (gID, 'red', this.gs.ICO_RED, 'tertiary', 'Read', idsufix); 
    if (append == 1) this.renderer.appendChild(ee, e);
  }
  else if (a['state'] == this.gs.MSGS_STATE_READ) { 
    e = this.getSlideOptionEl (gID, 'ured', this.gs.ICO_DOWNLOAD, 'success', 'UnRead', idsufix); 
    if (append == 1) this.renderer.appendChild(ee, e);
  }

  let av = document.getElementById('av1_' + gID); 
  if (av != null) { av.setAttribute ('color', color)}
}

setSlideAttr_blk (ee, ind, appen, gID, idsufix) {
  let e = null;
  if (this.gs.ITMS[ind]['a'][this.gs.flags1_offset] & this.gs.PROFILE_FLAG_BLOCKED) {
    e = this.getSlideOptionEl (gID, 'ublk', this.gs.ICO_X, 'success', 'UnBlock', idsufix); }
  else { e = this.getSlideOptionEl (gID, 'blk', this.gs.ICO_X, 'danger', 'Block', idsufix); }
  if (appen == 1) this.renderer.appendChild(ee, e);
}

setSlideAttr_flag (ee, ind, appen, gID, idsufix) {
  let e = null;
  if (this.gs.ITMS[ind]['a'][this.gs.ITMS[ ind ]['a'][this.gs.GT_flags_ind]] & this.gs.MSGS_FLAGS_FLAGGED) {
    e = this.getSlideOptionEl (gID, 'uflg', this.gs.ICO_FLG, 'tertiary', 'UnFlag', idsufix); }
  else { e = this.getSlideOptionEl (gID, 'flg', this.gs.ICO_FLG, 'danger', 'Flag', idsufix); }

  if (appen == 1) this.renderer.appendChild(ee, e);
}

// SLIDER OPTIONS       ////$$$
getSlideOptionEl (gID, act, ico, color, cap, idsufix) {

  let itemSO = document.getElementById(gID + '_op_' + idsufix);
  if (itemSO !== null) {
    itemSO.setAttribute ('data-act', act); this.renderer.setAttribute(itemSO, 'color', color);
    let ico1 = document.getElementById(gID + '_ic_' + idsufix); this.els.setIconName (ico, ico1);
    let l = document.getElementById(gID + '_lb_' + idsufix); l.innerHTML = cap;
  }
  else {
    let es = 'ion-item-option ;; id = ' + gID + '_op_' + idsufix + ' ;; data-act = ' + act;
    es += ' ;; class = slideOption ;; color = ' + color;
    itemSO = this.els.getEL (es);
    itemSO.addEventListener("click", () => { this. actionProccess (itemSO.dataset.act, gID, 0, 'slide');});
   
    es = 'ion-icon ;; name = ' + ico + ' ;; slot = bottom ;; id = ' + gID + '_ic_' + idsufix;
    let ico1 = this.els.getEL ( es);

    this.renderer.appendChild(itemSO, ico1);
    if (cap != '') {
      const l = this.els.createElem ('ion-lable', gID + '_lb_' + idsufix, cap);  
      this.renderer.appendChild(itemSO, l);
    }
  }

 return itemSO;
}

getActionClick (actid, gID) {
  let e;
  let ind = this.gs.findInd (gID); if (ind == -1) return;  // tmp remove later

  switch (actid) {
  case 'mmp': this.getContMenu (gID); break;
  case 'mm': this.getMsgMenu (gID); break;
  case '1': case '2': this.actionProccess (actid, gID, 1, 'actid'); break;
  case '0': this.getGsmsDiv (gID, 0); break;
  case '3': 
    e = document.getElementById ( gID + '_shi');
    if (e !== null) {this.els.deleteElement ( gID + '_shi'); break;}
    let c = this.els.showHis (ind, gID);
    break;
  }
}

refreshItemsVis (s, force) {
  this.gs.NOscrollTriger = true;
  this.ifClickedItemId ()
  let c = 0; 
  this.gs.lastVisInd = -1;
  let noShow = 0;
  let infsc = 0;
  let vis = 0;  
  
  if (this.gs.selectedSegm == '' && s == '') this.gs.selectedSegm = 'New';

  if (this.gs.selectedSegm != s || s == '' || force == 1) {
    if ( s == '') s = this.gs.selectedSegm; else this.gs.selectedSegm = s;
    this.gs.setTodayYesturday ();
    let ls = '@'+ s.toLowerCase();
    var d = this.els.clearInnerHTML ('mainDiv'); if (d === null) return;

    for(let i = 0; i < this.gs.ITMS.length; i++){ 
      this.gs.ITMS[ i ]['a'][ this.gs.isVis] = 0;
      this.gs.ITMS[ i ]['a'][ this.gs.isLoaded] = 0;
      if (this.gs.ITMS[i]['a'][this.gs.ifItemInSearch] == 0) continue;
      vis = 0; 
      noShow = 0; 
      if (s == 'All') vis = 1; 
      else if (this.gs.ITMS[i]['t'].toLowerCase().indexOf(ls) > -1 ) vis = 1;
      if ( this.gs.infinitScrollCount >= c ) { this.gs.lastVisInd = i; }
      else { noShow = 1; infsc = 1; }
      if (this.gs.ITMS[i]['a'][this.gs.isVis] != vis ) this.showHideEl (i, vis, noShow, 0);
      c += vis;
    }

    if (c == 0) this.els.sh_msgFiltsID (this.gs.showByClass);
  }

  let segs = this.els.createGSsigsTab();
  segs.addEventListener('ionChange', (ev) => this.onSegmentChange('segsMsgs', ev.detail.value));
  if (infsc == 1) { this.delay(this.gs.scrolTimeout).then( res => {this.gs.NOscrollTriger = false;});}
  this.goScrollToTop();
}

loadMoreItems() {
  let vis = 1;  let c = 0;
  for(let i = this.gs.lastVisInd + 1; i < this.gs.ITMS.length; i++){ 
    if (this.gs.infinitScrollCount >= c ) {
      this.gs.lastVisInd = i;
      if (this.gs.ITMS[i]['a'][this.gs.ifItemInSearch] == 0) continue;
      if ( this.gs.ITMS[ i ]['a'][ this.gs.isVis] == vis)  {
        this.showHideEl (i, vis, 0, 0); c++; }
    }
    else break;
  }
}

async logScrolling($event) {
  if(this.gs.NOscrollTriger) { return; }
  let scrollElement = await $event.target.getScrollElement();
  let scrollHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
  let currentScrollDepth = scrollElement.scrollTop;
  let triggerDepth = ((scrollHeight / 100) * this.gs.targetPercent);
  if(currentScrollDepth > triggerDepth) {
    //  console.log(`to ${this.gs.targetPercent}%`);
    this.gs.NOscrollTriger = true;
    this.loadMoreItems();
    if (this.gs.lastVisInd < this.gs.ITMS.length - 1) this.gs.NOscrollTriger = false; 
    else console.log(this.gs.lastVisInd + ' ' + (this.gs.ITMS.length - 1) );
  }
}

updateMsgActionRet (actID, ind) {
  // if auto read exit DOOOOOOOOOOOOOOOOOOOOOOOO
  let gID = this.gs.getID (ind);
  if (actID == 'con') {this.els.setCons (ind); return}
  
  this.gs.updateMsgGT (actID, ind);
  
  if (this.gs.refrence == 'slide') { 
    let e = document.getElementById ('mainDiv') as HTMLIonListElement;  e.closeSlidingItems();
  }

let a = this.gs.getAssocMsgArray (ind);
  this.els.getListStateBar(ind, gID, a);
  this.getItemSlidElement (ind, a, 0, this.gs.getID(ind));
}

doMsgActionRet (ind: number, actID) {
  let looop = 0;
  if (actID.indexOf ('all') > -1 ) looop = 1;

  switch (actID) {
    case 'blk': case 'ublk':
      this.gs.updateBlksRuts (this.gs.ITMS[ind]['a'][this.gs.conOffS]);
      looop = 1; break;
    default: break;
  }

  if (looop == 1) {
    for(let ii = 0; ii < this.gs.ITMS.length; ii++){
      if (this.gs.ITMS[ii]['a'][this.gs.conOffS] == this.gs.ITMS[ind]['a'][this.gs.conOffS]) { 
        this.updateMsgActionRet(actID, ii); 
      }}}
  else { this.updateMsgActionRet(actID, ind); }
}

actionProccess (actID, gID, conf, refrence) {
  let s = ''; 
  let ind = this.gs.findInd (gID); if (ind == -1) return;

  if (conf != 1) {
    this.goUrl (this.gs.getAction_Postdata (actID, ind, this.gs.ITMS[ind]['a'][this.gs.conOffS], refrence), gID);
    return;
  }
  
  const msg = ' all Messages for ' + this.gs.ITMS[ind]['a'][this.gs.conOffS] + ' ?';
  
  switch (actID)  {
  case 'flg' : s = 'Flag ?'; break; 
  case 'uflg' : s = 'UnFlag ?'; break;
  case 'del' : s = 'Delete ?'; break;
  case 'udel' : s = 'Restore ?'; break;
  
  case 'red' : s = 'Mark as Read ?'; break;
  case 'ured' : s = 'Mark as New ?'; break;

  case 'udelall' : s = 'Restore' + msg; break;
  case 'blk' : s = 'Block Number ' + msg; break;
  case 'ublk' : s = 'Unblock Number ' + msg;  actID = 'ublk'; break;
  case 'pugall' : s = 'PURGE' + msg + '<br>You Will NOT Be Able to Recover These Messages, PURGE ?'; break;
  case 'flgall' : s = 'Flag' + msg;  break;
  case 'uflgall' : s = 'UnFlag' + msg;  break;
  case 'delall' : s = 'Delete' + msg;  break;
  case 'redall' : s = 'Mark as Read' + msg;  break;
  case 'uredall' : s = 'Mark as UnRead' + msg;  break;
  default: break;
  }
  this.gs.showAlert('', '', s).then (res => {
    if (this.gs.resultRet == '-1') {this.els.openMenu ('m1', 0); return;}
    if (this.gs.resultRet == '0') return;
    this.goUrl (this.gs.getAction_Postdata (actID, ind, this.gs.ITMS[ind]['a'][this.gs.conOffS], refrence), gID);
  });
 
}

saveContactNameUrl (cn) {
  // let ind = this.gs.findInd (cn.dataset.ind); if (ind == -1) return;
  let ind = this.gs.findInd (this.gs.clickedItemId); if (ind == -1) return;

  this.gs.setConsNams (ind, cn.value) ;
  let s = '??cid=?=' + this.gs.ITMS[ind]['a'][this.gs.conOffS] ;
  s += '??actID=?=conE' + '??cname=?=' + cn.value;
  // this.goUrl (this.gs.getAction_Postdata ('con', ind, s, cn.value ), cn.dataset.ind);
  this.goUrl (this.gs.getAction_Postdata ('con', ind, s, cn.value ), this.gs.clickedItemId);
}


// CALL       ////$$$

retCallDiv (gID) {
  let id = 'call_' + gID;
  let div = this.els.createElem ('div', id, '', '', 'smsDiv'); 
  this.renderer.appendChild(div, this.els.getX_bar (id));
  return div;
}


// SMS       ////$$$

retSmsDiv (gID, isGsms) {
  let id = 'sms_' + gID;
  let from = this.gs.if_HasSmsDID (this.gs.didSel, 0); if (from == '') return null;
  
  let frmID = id + '_fr';
  let toID = id + '_to';
  let goID = id + '_go';
  let txtId = id + '_txt';

  let div = this.els.createElem ('div', id, '', '', 'smsDiv'); 
  this.renderer.appendChild(div, this.els.getX_bar (id));
  
  if (isGsms == 1) {
    this.renderer.appendChild(div, this.els.SmsFromSelect (from, 'From Number:', frmID ));
    // this.renderer.appendChild(div, this.els.getTextE ('text', toID, 'Tel: 8005551212', "To Number", 1, ''));
    this.renderer.appendChild(div, this.els.getTextE ('text', toID, '', "To Number", 1, ''));
  
    this.els.sh_allTopDivs (this.gs.hideByClass);
    this.els.sh_dsms (this.gs.showByClass);
  }
  else {
    let item = this.getItemSmsLable (gID, frmID, toID);
    if (div !== null) this.renderer.appendChild(div, item);
  }

  const but = this.els.createElem ('input', goID);
  this.renderer.appendChild(div, this.els.getSubmit (but, 'Send'));
  but.addEventListener("click", () => { this.smsGsend(gID); });

  this.renderer.appendChild(div, this.els.getSMStxta (txtId));
  return div;
}

getItemSmsLable (gID, frmID, toID) {
  let tb = document.getElementById (gID + '_from'); if (tb === null) return null;
  let s = tb.getAttribute ('data-from') + '????' ;
  let a = s.split ('??');
  if (a[0] == '' || a[1] == '') return null;

  let item = this.els.getEL ('ion-item ;; style = text-align: center;font-size: 14px;' );
  this.renderer.appendChild(item, this.els.createElem ('ion-lable', frmID, 'From: ' + a[0] + ' '));
  this.renderer.appendChild(item, this.els.createElem ('ion-lable', toID, 'To: ' + a[1]));
  return item;
  }

getGsmsDiv  (gID, isGsms) {
  let id;
  let div = this.retSmsDiv (gID, isGsms); if (div === null) return;
  if (isGsms == 0) { id = 'sr_' + gID; } else { id = 'dsms'; this.goScrollToTop (); }
  let eDiv = document.getElementById (id); if (eDiv === null) return;
  this.renderer.appendChild(eDiv, div);
}

getCallDiv  (gID) {

  console.log(gID)
  let div = this.retCallDiv (gID); if (div === null) return;
  if (gID == '') { this.goScrollToTop (); }

  let eDiv = document.getElementById ('dcall'); if (eDiv === null) return;
  eDiv.classList.remove ('hideEl')
  this.renderer.appendChild(eDiv, div);
}

smsGsend ( gID ) {
  if (this.gs.actionRes == 1) return;  // avoid double click on send
  let id = 'sms_' + gID;
  let from = ''; let to = '';  let too;

  let frmID = id + '_fr';
  let toID = id + '_to';
  let txtId = id + '_txt';
 
  let msg = document.getElementById(txtId) as HTMLInputElement; if (msg === null ) return;
  let frm = document.getElementById(frmID) as HTMLIonSelectOptionElement; if (frm === null) return;
  if (frm.value !== undefined) {
    from = frm.value
    too = document.getElementById(toID) as HTMLInputElement; if (too === null ) return;
    to = too.value
  }
  else {
    let tb = document.getElementById (gID + '_from'); if (tb === null) return null;
    let s = tb.getAttribute ('data-from') + '????' ;
    let a = s.split ('??');
    if (a[0] == '' || a[1] == '') return null;

    from = a[0];
    to = a[1];
  }

  if (this.gs.verifySmsSend (to, from, msg.value) == 0) return;
  this.goUrl (this.gs.sms_Postdata ({}, from, to, msg.value, 'sms'), 'smsTID' + id);
}


// SEARCH       ////$$$
goStrSearchR () {
  for(let ii = this.gs.ITMS.length - 1; ii >= 0; ii--) {
    if (this.set_ifItemInSearch (this.gs.ITMS[ii], ii) > -1) this.gs.ITMS[ii]['a'][this.gs.ifItemInSearch] = 1;
    else this.gs.ITMS[ii]['a'][this.gs.ifItemInSearch] = 0;
  }
  this.els.updateGSbadges ();
  this.refreshItemsVis (this.gs.selectedSegm, 1); 
}
getSearchStr(ev: any) {
  if (this.gs.activeID > -1) {this.getItemClick(this.gs.getID(this.gs.activeID), 0);}

  this.goScrollToTop ();

  if ( this.gs.searchData != '' && ev.target.value == '') {
    this.gs.searchData = '';
    for(let i = 0; i < this.gs.ITMS.length; i++){this.gs.ITMS[i]['a'][this.gs.ifItemInSearch] = 1;}
    this.refreshItemsVis (this.gs.selectedSegmSerch, 1); 
    this.gs.selectedSegmSerch = '';
    return;
  }

  if (this.gs.selectedSegm != '' && this.gs.selectedSegmSerch == '') {
     this.gs.selectedSegmSerch = this.gs.selectedSegm
     let e = document.getElementById('segsMsgs')  as HTMLIonSegmentElement ;
     if (e !== null) {e.value = 'All';}
     this.gs.selectedSegm = 'All';
  }

  this.ifClickedItemId ();
  this.gs.searchData = ev.target.value; 
  this.goStrSearchR();
}
set_ifItemInSearch (aa, ind: number) {
   if ( this.gs.searchData == '') {console.error('set_if ItemInSearch ????'); return;}
    let str = this.gs.searchData.toLowerCase();
    let a = this.gs.getAssocMsgArray (ind);
    let ss = aa['a'][this.gs.conOffS] + ' ' + a['cname'];
    let s = aa['t'];  if (s.toLowerCase().indexOf('text') > -1) ss += ' ' + a['body'] ;
    return ss.toLowerCase().indexOf(str);
}


        autoRead (a, gID) {
          if (a['p_fix'] != 'm_') return;
          if (a['state'] != this.gs.MSGS_STATE_UNREAD) return;
          if (a['type'] == this.gs.MSGS_TYPE_SENT) return;
          this.delay(this.gs.clickDelayDetailDiv).then( res => {this.actionProccess ('red', gID, 0, '');});
        }




}
